<article
    class="suggestion position-relative"
    [ngStyle]="{ 'background-image': backgroundImageStyle }"
>
    <div class="suggestion__content z-1 position-relative">
        <div class="content__container d-flex align-items-stretch">
            <a
                [routerLink]="routerLinkValue"
                class="content__link d-flex align-items-center text-white text-decoration-none"
            >
                <div class="d-flex flex-column justify-content-center gap-3">
                    <h3 class="link__title fs-4 m-0 fw-normal">
                        {{ suggestion.title }}
                    </h3>

                    <span class="link__learn-more position-relative">{{ suggestion.title ? ('Learn more about ' + suggestion.title) : 'Learn more' }}</span>
                </div>
            </a>
        </div>
    </div>
</article>
